export default __webpack_public_path__ + "static/assets/5c0af7b4b3fd566432384a9669b826fd.svg";